import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DictTownWithRoadsItem, DictTownWithStreetsItem } from './dictionary.common.model';

@Injectable({
  providedIn: 'root'
})
export class DictionaryCommonService {
  constructor(private httpClient: HttpClient) {
  }

  public getTownWithStreetsList(): Observable<DictTownWithStreetsItem[]> {
    return this.httpClient.get<DictTownWithStreetsItem[]>('resources/dict/town_street.json');
  }

  public getTownWithRoadsList(): Observable<DictTownWithRoadsItem[]> {
    return this.httpClient.get<DictTownWithRoadsItem[]>('resources/dict/town_road.json');
  }
}
